import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { Urls } from "../../constants/status-reason/status-reason.constants";
import { GetStatusReasonTransitionsResponse, GetAvailableTransitionsResponse } from "../../models/status-reason/status-reason.models";

@autoinject()
export class StatusReasonClientService {

    constructor(private requestClient: RequestClientService) {
    }

    getStatusReasonTransitions(): Promise<GetStatusReasonTransitionsResponse> {
        return this.requestClient.get<GetStatusReasonTransitionsResponse>(Urls.GetStatusReasonTransitions, {});
    }

    getAvailableStatusReasonTransitions(currentStatusReasonId: number, entityTypeId: number): Promise<GetAvailableTransitionsResponse> {
        return this.requestClient.get<GetAvailableTransitionsResponse>(Urls.GetAvailableStatusReasonTransitions, { currentStatusReasonId, entityTypeId });
    }

    save(changes: any) {
        return this.requestClient.post<GetStatusReasonTransitionsResponse>(Urls.SaveStatusReasonTransitions, {}, { changes });
    }
}